// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { FiAlertTriangle } from 'react-icons/fi';
import { isExitBlocked, getExitBlockReason } from '@/router/zustand/callStore';

export function isReloadOrCloseKey(e) {
  const key = String(e.key || '').toLowerCase();
  const mod = e.ctrlKey || e.metaKey;

  if (key === 'f5') return true;               // F5 / Ctrl+F5 / Shift+F5 (hard reload)
  if (mod && key === 'r') return true;         // Ctrl+R / Cmd+R / +Shift (hard reload)
  if (mod && key === 'w') return true;         // Ctrl+W / Cmd+W / +Shift (close tab/window)
  if (mod && key === 'q') return true;         // Ctrl+Q / Cmd+Q (quit browser)
  if (e.altKey && key === 'f4') return true;   // Alt+F4 (close window)
  if (mod && key === 'f4') return true;        // Ctrl+F4 (close tab, Windows)
  if (e.altKey && (key === 'arrowleft' || key === 'arrowright')) return true;  // back / forward
  if (mod && (key === 'arrowleft' || key === 'arrowright')) return true;       // back / forward (mac)
  if (mod && key === '[') return true;          // Cmd+[ back (mac)
  if (mod && key === ']') return true;          // Cmd+] forward (mac)
  return false;
}

export default function ExitGuard() {
  const [reason, setReason] = useState(null);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (!isExitBlocked()) return undefined;
      e.preventDefault();
      e.returnValue = getExitBlockReason() || 'You are on a call or filling a disposition.';
      return e.returnValue;
    };

    const handleKeyDown = (e) => {
      if (!isReloadOrCloseKey(e)) return;
      if (!isExitBlocked()) return;
      e.preventDefault();
      e.stopPropagation();
      setReason(getExitBlockReason() || 'You are on a call or filling a disposition.');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('keydown', handleKeyDown, true);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('keydown', handleKeyDown, true);
    };
  }, []);

  useEffect(() => {
    if (!reason) return undefined;
    const timer = setInterval(() => {
      if (!isExitBlocked()) setReason(null);
    }, 1000);
    return () => clearInterval(timer);
  }, [reason]);

  return (
    <Dialog open={Boolean(reason)} onOpenChange={(open) => { if (!open) setReason(null); }}>
      <DialogContent className="z-[1100] max-w-md" overlayClassName="z-[1090]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-destructive/10 text-destructive">
              <FiAlertTriangle size={16} />
            </span>
            You can't leave just yet
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">{reason}</p>
        <p className="text-sm text-muted-foreground">
          Refreshing or closing this page now would drop the call, and the disposition you're
          filling in would be lost. Please finish the call and submit the disposition first.
          Thank you!
        </p>
        <div className="flex justify-end">
          <Button onClick={() => setReason(null)}>OK, I'll stay</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
